/**
 * Shared Map Pin Helper Service
 */

var mapPinHelper = {

    brand: $('body').data('brand'),

    defaultPin: '<svg xmlns="http://www.w3.org/2000/svg" width="30.303" height="50" viewBox="0 0 30.303 50"><g id="Group_124" data-name="Group 124" transform="translate(-6533 -423)"><g id="Group_65" data-name="Group 65" transform="translate(6533 423)"><g id="Shape_1" data-name="Shape 1" transform="translate(-120 -101)" fill="#3e3e3e" stroke-linejoin="round"><path d="M 135.1515502929688 148.9373474121094 C 133.8139190673828 146.5016937255859 131.1291351318359 141.5261840820313 128.4701232910156 136.0876617431641 C 122.2959976196289 123.4596557617188 121 118.1388778686523 121 115.8989715576172 C 121 112.1896057128906 122.4699020385742 108.7013626098633 125.1389312744141 106.0768356323242 C 127.8124771118164 103.4478454589844 131.3683624267578 102.0000076293945 135.1515350341797 102.0000076293945 C 138.9347076416016 102.0000076293945 142.4905853271484 103.4478454589844 145.1641235351563 106.0768356323242 C 147.8331604003906 108.7013626098633 149.3030548095703 112.1896057128906 149.3030548095703 115.8989715576172 C 149.3030548095703 118.139533996582 148.0063629150391 123.4622650146484 141.8289337158203 136.0958557128906 C 139.1706085205078 141.5324859619141 136.4883575439453 146.5032501220703 135.1515502929688 148.9373474121094 Z" stroke="none"/><path d="M 135.1515350341797 103 C 131.6323089599609 103 128.3254241943359 104.3459167480469 125.8400726318359 106.7898559570313 C 123.3637542724609 109.2248687744141 122 112.4598999023438 122 115.8989715576172 C 122 117.6457366943359 122.9567565917969 122.533203125 129.3644866943359 135.6402282714844 C 131.5220794677734 140.0535888671875 133.6976623535156 144.1626892089844 135.1515350341797 146.8481750488281 C 136.6054077148438 144.1626892089844 138.7809906005859 140.0535888671875 140.9385681152344 135.6402282714844 C 147.3462829589844 122.533203125 148.3030395507813 117.6457366943359 148.3030395507813 115.8989715576172 C 148.3030395507813 112.4598999023438 146.9393005371094 109.2248687744141 144.4629821777344 106.7898559570313 C 141.9776306152344 104.3459167480469 138.6707611083984 103 135.1515350341797 103 M 135.1515350341797 101 C 143.5194396972656 101 150.3030395507813 107.6704864501953 150.3030395507813 115.8989715576172 C 150.3030395507813 124.12744140625 135.1515350341797 150.9999084472656 135.1515350341797 150.9999084472656 C 135.1515350341797 150.9999084472656 120 124.12744140625 120 115.8989715576172 C 120 107.6704864501953 126.7835998535156 101 135.1515350341797 101 Z" stroke="none" fill="#fff"/></g></g><circle id="Ellipse_1" data-name="Ellipse 1" cx="6" cy="6" r="6" transform="translate(6542 433)" fill="#fff"/></g></svg>',

    pins: {},

    loadMapPins: function () {
        var pinsScript = document.getElementById('sc-map-pins-json');
        if (pinsScript) {
            try {
                this.pins = JSON.parse(pinsScript.textContent);
            } catch (e) {
                this.pins = {};
            }
        } else {
            this.pins = {};
        }
    },

    getMapPinId: function (iconSvgProperties) {

        // if there is no brand name, set it to the current brand
        if (!iconSvgProperties.brandName) {
            iconSvgProperties.brandName = this.brand;
        }

        // convert Del Webb string for proper use
        if (iconSvgProperties.brandName === 'Del Webb') {
            iconSvgProperties.brandName = 'DelWebb';
        }

        // if there is no pin type, set it to exact
        if (!iconSvgProperties.pinType) {
            iconSvgProperties.pinType = 'exact';
        }

        // only allow active adult pins for Pulte for now to avoid errors for brands like Del Webb that always return active adult flag as true
        if (iconSvgProperties.brandName !== 'Pulte') {
            iconSvgProperties.isActiveAdult = false;
        }

        // construct the variable name for the desired pin
        var svgUrlVariableName = iconSvgProperties.brandName + "_";

        if (iconSvgProperties.isActiveAdult) {
            svgUrlVariableName += "ACTIVE_ADULT_"
        }

        if (iconSvgProperties.isDWExplore) {
            svgUrlVariableName += "EXPLORE_"
        }


        svgUrlVariableName += iconSvgProperties.pinType + "_PIN";

        return svgUrlVariableName.toUpperCase();
    },

    getSVGMapPinObject: function (iconSvgProperties) {

        var key = this.getMapPinId(iconSvgProperties);
        var svg = this.pins[key];
        if (!svg) svg = this.defaultPin;
        return svg;
    },

    /**
     * getGoogleMapPinObject: Return Google Map svg icon object
     * @param {Object} iconSvgProperties - icon svg properties object with scale, brandName, isActiveAdult, and pinType values
     */
    getGoogleMapPinObject: function (iconSvgProperties) {

        // Parse SVG to get attributes
        var mapPinSource = $.parseHTML(this.getSVGMapPinObject(iconSvgProperties));
        // Using 30.303 x 50 as fallback
        var pinWidth = mapPinSource.length && mapPinSource[0].getAttribute('width') > 0 ? mapPinSource[0].getAttribute('width') : 30.303;
        var pinHeight = mapPinSource.length && mapPinSource[0].getAttribute('height') > 0 ? mapPinSource[0].getAttribute('height') : 50;

        var iconWidth = pinWidth * iconSvgProperties.scale;
        var iconHeight = pinHeight * iconSvgProperties.scale;
        var svgUrl = 'data:image/svg+xml;base64,' + window.btoa(this.getSVGMapPinObject(iconSvgProperties));
        // Passing in google maps scaledSize for IE11 compatibility
        return { url: svgUrl, scaledSize: new google.maps.Size(iconWidth, iconHeight), size: new google.maps.Size(iconWidth, iconHeight) };
    },

    convertSvgToUrl: function (svgHtmlString) {
        return 'data:image/svg+xml;base64,' + window.btoa(svgHtmlString);
    }
};

mapPinHelper.loadMapPins();


module.exports = mapPinHelper;
